import { render, staticRenderFns } from "./TgAppBar.vue?vue&type=template&id=58340ce0"
import script from "./TgAppBar.vue?vue&type=script&lang=js"
export * from "./TgAppBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports